import {Button} from 'components/Button';
import {Typography} from 'components/Typography';
import {EventsListContext} from 'modules/events/context';
import {FC, useContext} from 'react';
import style from './style.module.scss';

export const LoadMoreEvents: FC = () => {
    const {canLoadMore, loadMoreEvents} = useContext(EventsListContext);

    if (!canLoadMore) {
        return null;
    }

    return (
        <Button className={style.main} isStretched={true} onClick={loadMoreEvents} theme={'outline'}>
            <Typography variant={'button-14-m-cl'}>Загрузить еще</Typography>
        </Button>
    );
};
